import React from "react";

import { DialogContent } from "@material-ui/core";

import { Loader } from "../index";

type Props = {
  children: React.ReactNode;
  loading?: boolean;
  loadOverlaid?: any;
};

export default function Content({
  children,
  loading,
  loadOverlaid,
  ...props
}: Props) {
  return (
    <DialogContent dividers {...props}>
      <Loader loading={loading} overlay={loadOverlaid}>
        {children}
      </Loader>
    </DialogContent>
  );
}
